import Vue from 'vue';
import Router from 'vue-router';
import { Token } from '@atabix/core';
import store from '@/store';
import Guard from '@/support/Guard';
// import Contact from '@/views/Users/Contact/Contact';
// import Support from '@/views/Users/Support/Support';
import Homepage from '@/views/Homepage/Homepage';

Vue.use(Router);

const router: Router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Homepage,
      meta: { requiresAuth: false, name: 'home' },
    },
    {
      path: '/leads',
      name: 'leads.index',
      component: () => import(/* webpackChunkName: "leads" */ '@/views/Users/Users'),
      meta: { requiresAuth: true, type: 'Leads', model: 'Lead', name: 'leads', category: 'leads' },
    },
    {
      path: '/leads/:id',
      name: 'leads.show',
      component: () => import(/* webpackChunkName: "lead" */ '@/views/Users/User'),
      meta: { requiresAuth: true, type: 'Leads', model: 'Lead', name: 'leads', category: 'leads' },
    },
    {
      path: '/stylisten',
      name: 'stylists.index',
      component: () => import(/* webpackChunkName: "stylists" */ '@/views/Users/Users'),
      meta: { requiresAuth: true, type: 'Stylists', model: 'Stylist', name: 'stylisten', category: 'users' },
    },
    {
      path: '/stylisten/:id',
      name: 'stylists.show',
      component: () => import(/* webpackChunkName: "stylist" */ '@/views/Users/User'),
      meta: { requiresAuth: true, type: 'Stylists', model: 'Stylist', name: 'stylisten', category: 'users' },
    },
    {
      path: '/contacten',
      name: 'contacts.index',
      component: () => import(/* webpackChunkName: "contacts" */ '@/views/Users/Users'),
      meta: { requiresAuth: true, type: 'Contacts', model: 'Contact', name: 'contacten', category: 'contacts' },
    },
    {
      path: '/contacten/:id',
      name: 'contacten.show',
      component: () => import(/* webpackChunkName: "contact" */ '@/views/Users/User'),
      meta: { requiresAuth: true, type: 'Contacts', model: 'Contact', name: 'contacten', category: 'contacts' },
    },
    {
      path: '/leveranciers',
      name: 'suppliers.index',
      component: () => import(/* webpackChunkName: "suppliers" */ '@/views/Users/Users'),
      meta: { requiresAuth: true, type: 'Suppliers', model: 'Supplier', name: 'leveranciers', category: 'suppliers' },
    },
    {
      path: '/leveranciers/:id',
      name: 'suppliers.show',
      component: () => import(/* webpackChunkName: "supplier" */ '@/views/Suppliers/Supplier'),
      meta: { requiresAuth: true, type: 'Suppliers', model: 'Supplier', name: 'leveranciers', category: 'suppliers' },
    },
    {
      path: '/settings',
      name: 'settings.index',
      component: () => import(/* webpackChunkName: "settings" */ '@/views/Settings/Settings'),
      meta: { requiresAuth: true, type: 'Settings', model: 'Setting', name: 'settings', category: 'settings' },
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import(/* webpackChunkName: "orders" */ '@/views/Orders/Orders'),
      meta: { requiresAuth: true, type: 'Orders', name: 'orders', category: 'orders' },
    },
    {
      path: '/aanvragen',
      name: 'requests',
      component: () => import(/* webpackChunkName: "requests" */ '@/views/Requests/Requests'),
      meta: { requiresAuth: true, type: 'Requests', name: 'requests', category: 'requests' },
    },
    {
      path: '/aanvragen/:id',
      name: 'request',
      component: () => import(/* webpackChunkName: "request" */ '@/views/Requests/Request'),
      meta: { requiresAuth: true, type: 'Request', name: 'request', category: 'request' },
    },
    {
      path: '/styling-fees',
      name: 'orderFees',
      component: () => import(/* webpackChunkName: "order-fees" */ '@/views/OrderFee/OrderFees'),
      meta: { requiresAuth: true, type: 'OrderFees', name: 'styling fees', category: 'order fee' },
    },
    {
      path: '/styling-fees/:id',
      name: 'orderFees.detail',
      component: () => import(/* webpackChunkName: "order-fee" */ '@/views/OrderFee/OrderFee'),
      meta: { requiresAuth: true, type: 'OrderFee', name: 'styling fees', category: 'order fee' },
    },
    {
      path: '/webshop/order',
      name: 'webshop',
      component: () => import(/* webpackChunkName: "webshop" */ '@/views/Webshop/Webshop'),
      props: true,
      meta: { requiresAuth: true, name: 'webshop', category: 'orders' },
    },
    {
      path: '/webshop/order/:id',
      name: 'webshop.order',
      component: () => import(/* webpackChunkName: "webshop-order" */ '@/views/Webshop/Webshop'),
      props: true,
      meta: { requiresAuth: true, name: 'webshop', category: 'orders' },
    },
    {
      path: '/webshop/order/:id/product/:productId',
      name: 'webshop.order.detail',
      component: () => import(/* webpackChunkName: "webshop-order-product" */ '@/views/Webshop/ProductDetail/ProductDetail'),
      props: true,
      meta: { requiresAuth: true, name: 'Product detail', category: 'orders' },
    },
    {
      path: '/webshop/order/:id/sets',
      name: 'webshop.order.sets',
      component: () => import(/* webpackChunkName: "webshop-order-sets" */ '@/views/Webshop/OrderSets/OrderSets'),
      props: true,
      meta: { requiresAuth: true, name: 'webshop order sets', category: 'orders' },
    },
    {
      path: '/webshop/order/:id/order-overview',
      name: 'webshop.order.overview',
      component: () => import(/* webpackChunkName: "webshop-order-overview" */ '@/views/Webshop/OrderOverview/OrderOverview'),
      props: true,
      meta: { requiresAuth: true, name: 'webshop order overview', category: 'orders' },
    },
    {
      path: '/webshop/order/:id/order-detail',
      name: 'webshop.finalizedOrder.detail',
      component: () => import(/* webpackChunkName: "webshop-order-detail" */ '@/views/Webshop/OrderDetail/OrderDetail'),
      props: true,
      meta: { requiresAuth: true, name: 'webshop order detail', category: 'orders' },
    },
    {
      path: '/admin',
      name: 'admin.index',
      component: () => import(/* webpackChunkName: "admin-users" */ '@/views/Users/Users'),
      meta: { requiresAuth: true, type: 'Admin', name: 'admin', category: 'users' },
    },
    {
      path: '/admin/:id',
      name: 'admin.show',
      component: () => import(/* webpackChunkName: "admin-user" */ '@/views/Users/User'),
      meta: { requiresAuth: true, type: 'Admin', model: 'Admin', name: 'admin', category: 'users' },
    },
    {
      path: '/support',
      name: 'support.index',
      component: () => import(/* webpackChunkName: "support-users" */ '@/views/Users/Users'),
      meta: { requiresAuth: true, type: 'Support', name: 'support', category: 'users' },
    },
    {
      path: '/support/:id',
      name: 'support.show',
      component: () => import(/* webpackChunkName: "support-user" */ '@/views/Users/User'),
      meta: { requiresAuth: true, type: 'Support', model:  'Support', name: 'support', category: 'users' },
    },
    {
      path: '/producten',
      name: 'products',
      component: () => import(/* webpackChunkName: "products" */ '@/views/Products/Products'),
      meta: { requiresAuth: true, type: 'Products', name: 'producten', category: 'products' },
    },
    {
      path: '/producten/:id',
      name: 'products.show',
      component: () => import(/* webpackChunkName: "product" */ '@/views/Products/Product'),
      meta: { requiresAuth: true, type: 'Products', name: 'product', category: 'products' },
    },
    {
      path: '/varianten',
      name: 'variants',
      component: () => import(/* webpackChunkName: "variants" */ '@/views/Variants/Variants'),
      meta: { requiresAuth: true, type: 'Variants', name: 'varianten', category: 'variants' },
    },
    {
      path: '/varianten/:id',
      name: 'variants.show',
      component: () => import(/* webpackChunkName: "variant" */ '@/views/Variants/Variant'),
      meta: { requiresAuth: true, type: 'Variants', name: 'variant', category: 'variants' },
    },
    {
      path: '/purchase-orders',
      name: 'purchase-orders',
      component: () => import(/* webpackChunkName: "purchase-orders" */ '@/views/PurchaseOrders/PurchaseOrders.vue'),
      meta: { requiresAuth: true, type: 'Purchase orders', name: 'purchase-orders', category: 'purchase-orders' },
    },
    {
      path: '/purchase-orders/:id',
      name: 'purchase-order',
      component: () => import(/* webpackChunkName: "purchase-order" */ '@/views/PurchaseOrders/PurchaseOrder.vue'),
      meta: { requiresAuth: true, type: 'Purchase orders', name: 'purchase-order', category: 'purchase-orders' },
      children: [
        {
          path: 'order-items',
          name: 'purchase-order-order-items',
          meta: { category: 'purchase-orders' },
          component: () => import(/* webpackChunkName: "purchase-order-order-items" */ '@/views/PurchaseOrders/OrderItems/PurchaseOrderOrderItems.vue'),
        },
        {
          path: 'order-summary',
          name: 'purchase-order-order-summary',
          meta: { category: 'purchase-orders' },
          component: () => import(/* webpackChunkName: "purchase-order-order-summary" */ '@/views/PurchaseOrders/OrderSummary/PurchaseOrderOrderSummary.vue'),
        },
        {
          path: 'goods-in',
          name: 'purchase-order-goods-in',
          meta: { category: 'purchase-orders' },
          component: () => import(/* webpackChunkName: "purchase-order-goods-in" */ '@/views/PurchaseOrders/GoodsIn/PurchaseOrderGoodsIn.vue'),
        },
        {
          path: 'attachments',
          name: 'purchase-order-attachments',
          meta: { category: 'purchase-orders' },
          component: () => import(/* webpackChunkName: "purchase-order-attachments" */ '@/views/PurchaseOrders/Attachments/PurchaseOrderAttachments.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/Login'),
      meta: { requiresGuest: true, name: 'login' },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "logout" */ '@/views/Auth/Login'),
      meta: { requiresAuth: true, name: "logout"},
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import(/* webpackChunkName: "forgot-password" */ '@/views/ForgotPassword/ForgotPassword'),
      meta: { requiresGuest: true },
    },
    {
      path: '*',
      name: '404',
      component: () => import(/* webpackChunkName: "page-not-found" */ '@/views/Errors/PageNotFound'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const lang = to.params.lang;
  store.state.router = { current: to, previous: from };

  if (to.matched.some(Guard.auth)) {
    if (!Token.get('access')) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    } else if (to.matched.some((record) => record.meta.requiresGuest)) {
      next({
        path: '/',
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
